export default __webpack_public_path__ + "static/media/arrow-down.a649d0f5.svg";